import Isometric_Square_turquoise from "../../assets/Isometric_Square_turquoise.svg";
import Isometric_Square_light_blue from "../../assets/Isometric_Square_light-blue.svg";
import Isometric_Square_orange from "../../assets/Isometric_Square_orange.svg";
import Isometric_Square_red from "../../assets/Isometric_Square_red.svg";
import Isometric_Square_pink from "../../assets/Isometric_Square_pink.svg";
import Isometric_Square_raspberry from "../../assets/Isometric_Square_raspberry.svg";
// import Isometric_Square_caribbean_green from '../../assets/Isometric_Square_caribbean-green.svg'

const squares = [
    Isometric_Square_turquoise,
    Isometric_Square_light_blue,
    Isometric_Square_orange,
    Isometric_Square_red,
    Isometric_Square_pink,
    Isometric_Square_raspberry,
    // Isometric_Square_caribbean_green
];

export default squares;
